import Vue from 'vue'

/**
 * @author Mariela Temozihui Tlahuel <mariela.temozihui@jbge.com.mx>
 *
 * list status
 */

const fetchStatus = () =>
  Vue.$http.get(`catalogs/common/status/`)
    .then(response => {
      return response.data
    })
    .catch(err => {
      throw err
    })

export default fetchStatus



// WEBPACK FOOTER //
// ./src/services/purchase/quotation/fetchStatus.js